import { TransitionDto } from "@repo/api/transition";
import { AbsoluteFill } from "remotion";
import ImageTransitionPreview from "./components/TransitionPreview/ImageTransitionPreview.tsx";
import { preloadVideo } from "@remotion/preload";
import { useEffect } from "react";
import TransitionPreviewBackground from "./components/TransitionPreview/TransitionPreviewBackground.tsx";

export type ImageTransitionCompositionProps = {
  transition: TransitionDto;
  clip1DurationInFrames: number;
  clip2DurationInFrames: number;
};

const preloadedUrls = new Set<string>();

export const PREVIEW_CLIP_URLS = [
  "/transitions/CLIP_1.mp4",
  "/transitions/CLIP_2.mp4",
];

export async function preloadPreviewClips() {
  PREVIEW_CLIP_URLS.forEach((url) => {
    if (preloadedUrls.has(url)) {
      return;
    }

    preloadVideo(url);
    preloadedUrls.add(url);
  });
}

export default function ImageTransitionComposition({
  transition,
  clip1DurationInFrames,
  clip2DurationInFrames,
}: ImageTransitionCompositionProps) {
  useEffect(() => {
    preloadPreviewClips();
  }, []);

  return (
    <AbsoluteFill>
      <TransitionPreviewBackground />
      <ImageTransitionPreview
        transition={transition}
        clip1DurationInFrames={clip1DurationInFrames}
        clip2DurationInFrames={clip2DurationInFrames}
      />
    </AbsoluteFill>
  );
}
